import { myGet, myPost, handleGetError, handlePostError } from '../utils/myAxios'
import { servAddr } from '../servAddr'
import { store } from '../index'

export function fetchOrders() {
  return dispatch => {
    myGet(dispatch, servAddr + 'order').then((response) => {
      dispatch({type: "FETCH_COMPS", payload: response.data.comps});
      dispatch({type: "FETCH_EMPLS", payload: response.data.empls});
      dispatch({type: "FETCH_STTSS", payload: response.data.sttss});
      dispatch({type: "FETCH_ORDERS", payload: response.data.orders});
      dispatch({type: "FETCH_PERCS", payload: response.data.percs});
      dispatch({type: "FETCH_PLACES", payload: response.data.places});
      dispatch({type: "FETCH_ETYPES", payload: response.data.etypes});
      dispatch({type: "FETCH_PRODUCTS", payload: response.data.products});
    }, err => {
      handleGetError(dispatch, err);
    });
  }
}

export function filterOrders(filter) {
  return {
    type: 'FILTER_ORDERS',
    filter: filter
  };
}

export function sortOrders(sort) {
  return {
    type: 'SORT_ORDERS',
    sort: sort
  };
}

export function searchOrders(search) {
  return {
    type: 'SEARCH_ORDERS',
    search: search
  };
}

export function updateBalance(id, difS, difB1, difB2) {
  return {
    type: "EDIT_BALANCE",
    id: parseInt(id,10),
    difS: parseInt(difS,10),
    difB1: parseInt(difB1,10),
    difB2: parseInt(difB2,10)
  };
}

export function editOrder(order, cb = () => {}) {
  const state = store.getState();
  const model = state.auth.rights.order_post === 1 ? 'order' :
    'order_assigned';
  return dispatch => {
    myPost(dispatch, servAddr + model, {data: order}).then((response) => {
      if(order.order_id && !order.duplicate_order){
        cb();
        dispatch({type: "EDIT_ORDER", payload: order});
      }
      else{
        cb(null, response.data.id);
        dispatch({
          type: "CREATE_ORDER",
          payload: {
            ...order,
            order_num:response.data.num,
            order_id:response.data.id,
            p1_balance: null,
            p2_balance: null,
            p1_srvcsum: null,
            p1_order_id: null
          }
        });
      }
    }, err => {
      handlePostError(dispatch, err, cb);
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/orderActions.js